export default __webpack_public_path__ + "static/brush1-a77c17b3bb55e90df6352f241b0dd799.png";